(() => {
  function init(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const text = JSON.parse(root.querySelector('[data-text]').textContent);
    const steps = [...root.querySelectorAll('[data-step]')];
    const cards = [...root.querySelectorAll('[data-product]')];
    const answer = {};
    let matches = [];
    let step = 0;
    const results = root.querySelector('[data-results]');
    const next = root.querySelector('[data-next]');
    const back = root.querySelector('[data-back]');
    const progress = root.querySelector('[data-progress]');
    const status = root.querySelector('[data-status]');
    const labels = {};
    steps.forEach(s => { labels[s.dataset.key] = {}; s.querySelectorAll('input').forEach(i => labels[s.dataset.key][i.value] = i.nextElementSibling.firstChild.textContent.trim()); });
    const tokens = {
      fresh: /\b(fresh|citrus|aquatic|marine|bergamot|lemon|grapefruit|mandarin|mint|green|aromatic)\b/i,
      sweet: /\b(sweet|gourmand|vanilla|caramel|praline|honey|chocolate|cacao|coffee|tonka)\b/i,
      floral: /\b(floral|rose|jasmine|peony|freesia|gardenia|tuberose|iris|violet|orange blossom)\b/i,
      woody: /\b(woody|wood|woods|oud|sandalwood|cedar|vetiver|patchouli|leather|smoky|incense)\b/i
    };
    function show() {
      steps.forEach((s, i) => s.hidden = i !== step);
      results.hidden = true;
      root.querySelector('[data-questions]').hidden = false;
      progress.max = steps.length;
      progress.value = step + 1;
      status.textContent = text.step.replace('{current}', step + 1).replace('{total}', steps.length);
      back.hidden = step === 0;
      next.textContent = step === steps.length - 1 ? text.matches : text.next;
      next.disabled = !answer[steps[step].dataset.key];
    }
    function rank(card) {
      const d = card.dataset;
      const price = Number(d.price);
      if (!Number.isFinite(price)) return null;
      if (answer.budget === 'under50' && price > 5000) return null;
      if (answer.budget === '50to100' && (price <= 5000 || price > 10000)) return null;
      if (answer.budget === '100plus' && price <= 10000) return null;
      if (answer.style !== 'any' && d.style !== answer.style && d.style !== 'unisex') return null;
      const evidence = d.tags + ' ' + d.description;
      if (!tokens[answer.family].test(evidence)) return null;
      let score = tokens[answer.family].test(d.tags) ? 8 : 4;
      const occasion = answer.occasion === 'everyday' ? /everyday|daily|office|casual|versatile/i : /evening|date night|special occasion|formal/i;
      const occasionMatch = occasion.test(evidence);
      if (occasionMatch) score += 3;
      if (d.style === answer.style) score += 2;
      return {card, score, occasionMatch};
    }
    function recommend(moveFocus = true) {
      root.querySelector('[data-questions]').hidden = true;
      results.hidden = false;
      cards.forEach(c => c.hidden = true);
      const ranked = cards.map(rank).filter(Boolean).sort((a, b) => b.score - a.score || Number(a.card.dataset.price) - Number(b.card.dataset.price)).slice(0, 3);
      matches = ranked.map(item => item.card);
      const grid = root.querySelector('[data-grid]');
      ranked.forEach(({card, occasionMatch}) => {
        card.hidden = false;
        card.querySelector('[data-reason]').textContent = text.reason.replace('{family}', labels.family[answer.family].toLowerCase()) + (occasionMatch ? ' ' + text.occasion.replace('{occasion}', labels.occasion[answer.occasion].toLowerCase()) : '');
        grid.append(card);
      });
      root.querySelector('[data-result-note]').textContent = ranked.length ? text.result_note : text.no_matches;
      root.querySelector('[data-summary]').textContent = [labels.style[answer.style], labels.family[answer.family], labels.occasion[answer.occasion], labels.budget[answer.budget]].join(' · ');
      try { sessionStorage.setItem('luxe-scent-quiz', JSON.stringify(answer)); } catch {}
      if (moveFocus) root.querySelector('[data-result-heading]').focus();
    }
    root.addEventListener('change', e => {
      if (!e.target.matches('[data-step] input')) return;
      const group = e.target.closest('[data-step]');
      answer[group.dataset.key] = e.target.value;
      next.disabled = false;
    });
    next.addEventListener('click', () => {
      if (!answer[steps[step].dataset.key]) return;
      if (step === steps.length - 1) recommend();
      else {step++; show(); steps[step].querySelector('legend').focus();}
    });
    back.addEventListener('click', () => {step--; show(); steps[step].querySelector('legend').focus();});
    root.querySelector('[data-restart]').addEventListener('click', () => {step = 0; show(); steps[0].querySelector('legend').focus();});
    const signup = root.querySelector('[data-newsletter-form]');
    signup.addEventListener('submit', async e => {
      e.preventDefault();
      if (!signup.reportValidity()) return;
      const button = signup.querySelector('button[type="submit"]');
      const message = signup.querySelector('[data-signup-status]');
      button.disabled = true;
      message.classList.remove('lq-error');
      message.textContent = text.submitting;
      const properties = {quiz_family: labels.family[answer.family], quiz_style: labels.style[answer.style], quiz_occasion: labels.occasion[answer.occasion], quiz_budget: labels.budget[answer.budget], quiz_source: 'Find Your Scent'};
      for (let i = 1; i <= 3; i++) {
        const card = matches[i - 1];
        properties['quiz_match_' + i + '_name'] = card ? card.querySelector('h3').textContent.trim() : '';
        properties['quiz_match_' + i + '_url'] = card ? card.querySelector('a').href : '';
        properties['quiz_match_' + i + '_image'] = card ? (card.querySelector('img')?.src || '') : '';
        properties['quiz_match_' + i + '_reason'] = card ? card.querySelector('[data-reason]').textContent : '';
      }
      try {
        const response = await fetch('https://a.klaviyo.com/client/subscriptions?company_id=TpHNQc', {
          method: 'POST', headers: {'Content-Type': 'application/vnd.api+json', revision: '2025-07-15'},
          body: JSON.stringify({data: {type: 'subscription', attributes: {custom_source: 'Luxe Aroma Find Your Scent Quiz', profile: {data: {type: 'profile', attributes: {email: signup.querySelector('[type="email"]').value.trim(), properties}}}}, relationships: {list: {data: {type: 'list', id: 'WaMQQG'}}}}})
        });
        if (!response.ok) throw new Error('Subscription failed');
        message.textContent = text.success;
      } catch {
        message.classList.add('lq-error');
        message.textContent = text.signup_error;
      } finally { button.disabled = false; }
    });
    show();
    try {
      if (sessionStorage.getItem('luxe-scent-quiz-return')) {
        const saved = JSON.parse(sessionStorage.getItem('luxe-scent-quiz'));
        if (saved && steps.every(s => labels[s.dataset.key][saved[s.dataset.key]])) {
          Object.assign(answer, saved);
          steps.forEach(s => { const i = [...s.querySelectorAll('input')].find(i => i.value === answer[s.dataset.key]); if(i) i.checked = true; });
          recommend(false);
        }
        sessionStorage.removeItem('luxe-scent-quiz-return');
      }
    } catch {}
  }
  document.querySelectorAll('[data-scent-quiz]').forEach(init);
  document.addEventListener('shopify:section:load', e => e.target.querySelectorAll('[data-scent-quiz]').forEach(init));
})();
